export default __webpack_public_path__ + "static/media/finder_list_enable.303f050f.svg";